const rawMaterialApi = {
  CREATE_RAW_MATERIAL: `/api/restaurant/rawmaterial/create`,
  UPDATE_RAW_MATERIAL: `/api/restaurant/rawmaterial/update`,
  DELETE_RAW_MATERIAL: `/api/restaurant/rawmaterial/delete`,
  GET_RAW_MATERIAL: `/api/restaurant/rawmaterial`,
  GET_RAW_MATERIAL_DAILY: `/api/restaurant/rawmaterialdaily`,
  UPDATE_RAW_MATERIAL_DAILY: `/api/restaurant/rawmaterialdaily/update`,
};
export default rawMaterialApi;
